import React from 'react';
import { Link } from 'gatsby';
import ExternalLink from './ExternalLink';
import isInternalLink from '../utils/isInternalLink';
import isFFUrl from '../utils/isFFUrl';

/**
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - react children argument
 * @param {string=} props.className - classes to add to button
 * @param {string} props.url - url to use for the link
 * @param {React.MouseEventHandler=} props.onClick - any additional behavior to happen on click
 */
export default function FFLink({ children, className, url, ...otherProps }) {
  // Use Gatsby Link for internal links, and <a> for others
  const internalLinkResult = isInternalLink(url);
  if (internalLinkResult) {
    return (
      <Link {...otherProps} to={internalLinkResult} className={className}>
        {children}
      </Link>
    );
  }
  return isFFUrl(url) || url.startsWith('#') ? (
    <a {...otherProps} href={url} className={className}>
      {children}
    </a>
  ) : (
    <ExternalLink {...otherProps} href={url} className={className}>
      {children}
    </ExternalLink>
  );
}
